// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { initializeFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

// Same Firebase project as BuildMyChecks
const firebaseConfig = {
  apiKey: "AIzaSyAMd3a_Y2S3QHDAJFDiqxJWnWhhMDbHXe4",
  authDomain: "buildmychecks-prod.firebaseapp.com",
  projectId: "buildmychecks-prod",
  storageBucket: "buildmychecks-prod.firebasestorage.app",
  messagingSenderId: "252908575213",
  appId: "1:252908575213:web:5aac89e6096ff5fdeb2fe4",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = initializeFirestore(app, {
  experimentalForceLongPolling: true,
});
export const storage = getStorage(app);
export const functions = getFunctions(app, "europe-west2");
